<template>
  <v-card outlined>
    <v-card-title>
      Categories
      <v-spacer />
      <v-icon @click="edit(null)"> add </v-icon>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :items="categories"
      :headers="headers"
      disable-pagination
      hide-default-footer
      class="row-pointer"
      mobile-breakpoint="0"
      @click:row="rowClick"
    >
      <template #[`item.publishedCount`]="{ item }">
        {{ item.publishedCount }}
      </template>
      <template #[`item.notPublishedCount`]="{ item }">
        {{ item.notPublishedCount }}
      </template>
      <template #[`item.notes`]="{ item }">
        <v-icon :color="item.notes ? 'success' : undefined">
          {{ item.notes ? 'check_circle' : 'remove' }}
        </v-icon>
      </template>
      <template #[`item.catalogContentPageId`]="{ item }">
        <v-icon :color="item.catalogContentPageId ? 'success' : undefined">
          {{ item.catalogContentPageId ? 'check_circle' : 'remove' }}
        </v-icon>
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
    <EditDesignGroupCategory @save="$emit('reload')" />
  </v-card>
</template>

<script>
import EditDesignGroupCategory from '@/components/designgroups/category/Edit';
import { mapGetters } from 'vuex';
export default {
  name: 'DesignGroupCategories',
  components: { EditDesignGroupCategory },
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'categoryName' },
        { text: 'Published', value: 'publishedCount' },
        { text: 'Not Published', value: 'notPublishedCount' },
        { text: 'Notes', value: 'notes' },
        { text: 'Page', value: 'catalogContentPageId' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    categories() {
      let list = this.all_categories.map((x) => ({
        categoryId: x.id,
        categoryName: x.name,
        publishedCount: this.publishedCount(x.id),
        notPublishedCount: this.notPublishedCount(x.id)
      }));

      if (this.designgroup && this.designgroup.categories) {
        list = list.map((x) => {
          const item = this.designgroup.categories.find((y) => x.categoryId === y.category.id);
          if (!item) {
            return x;
          }
          return Object.assign(x, {
            id: item.id,
            notes: item.notes,
            description: item.description,
            catalogContentPageId: this.catalog_content_page_id(item.category.id)
          });
        });
      }
      return list.filter(
        (x) => x.publishedCount || x.notPublishedCount || x.notes || x.description || x.id
      );
    },
    publishedCount() {
      return (categoryId) => {
        return this.templates.filter((x) => x.categoryId === categoryId && x.published).length;
      };
    },
    notPublishedCount() {
      return (categoryId) => {
        return this.templates.filter((x) => x.categoryId === categoryId && !x.published).length;
      };
    },
    catalog_content_page_id() {
      return (categoryId) => {
        return this.catalog_content_pages
          .filter((x) => x.designGroupId === this.designgroup.id && x.categoryId === categoryId)
          .map((x) => x.id)[0];
      };
    },
    ...mapGetters({
      designgroup: 'designgroups/designgroup',
      templates: 'templates/list',
      all_categories: 'lookup/categories',
      catalog_content_pages: 'lookup/catalog_content_pages'
    })
  },
  mounted() {},
  methods: {
    rowClick(item) {
      this.edit(item.categoryId);
    },
    edit(categoryId) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.DESIGN_GROUP_CATEGORY_SHOW, {
        categoryId: categoryId,
        designGroupId: this.designgroup.id
      });
    }
  }
};
</script>
